/*
 * Konfigurator legowiska — filtrowanie siatki na stronie głównej.
 *
 * Dwa wymiary działające razem:
 *  - RODZAJ (kółka z kolekcjami),
 *  - KOLOR (paleta).
 *
 * Kliknięcie zostawia w siatce karty spełniające oba warunki, a przy wybranym
 * kolorze podmienia kadr karty na zdjęcie wariantu w tej barwie — klient od
 * razu widzi, jak legowisko wygląda w wybranym kolorze.
 *
 * WYPRZEDAŻ (rodzaj z `data-bez-koloru`): pokazujemy CAŁĄ wyprzedaż, a nie
 * przecięcie z siatką. Karty są wcześniej wyrenderowane jako `.filtr-zapas`
 * (sections/featured-collection.liquid, ustawienie „Kolekcja w zapasie") i
 * czekają schowane. Paleta kolorów jest wtedy wyłączona, bo te karty nie
 * pochodzą z kolekcji, z której zbudowano paletę.
 *
 * Skąd dane:
 *  - kolory: `data-kolory` na `<ul class="card-swatches">` (snippets/card-swatches.liquid),
 *    format `etykieta|adres dużego zdjęcia` rozdzielony znakiem §. Bierzemy je stamtąd,
 *    a nie z widocznych próbek, bo tych jest maksymalnie sześć na kartę.
 *  - rodzaj: `data-produkty` na kółku — lista uchwytów produktów z kolekcji.
 *    Uchwyt karty wyciągamy z adresu w jej linku, więc karty nie potrzebują
 *    dodatkowych atrybutów.
 *
 * Filtr jest wyłącznie wizualny: nie przeładowuje strony i nie zmienia adresu.
 */
(function () {
  /*
   * Skrypt wpinają dwie sekcje (konfigurator i starszy pasek kółek), a obie
   * mogą stać na jednej stronie. Bez blokady zdarzenia obsłużyłyby się dwa
   * razy, każdy egzemplarz z własnym stanem.
   */
  if (window.__filtrySiatki) return;
  window.__filtrySiatki = true;

  var ROZDZIELNIK_POZYCJI = '§';
  var UKRYTA = 'filtr-kolorow--ukryta';

  var stan = { rodzaj: '', rodzajPodpis: '', kolor: '', rasa: '', rozmiary: [], uchwyty: null, zapas: false };

  function panel() {
    return document.querySelector('[data-konfigurator]') || document.querySelector('[data-filtr-kolorow]');
  }

  /*
   * Siatka do filtrowania: pierwsza siatka produktów LEŻĄCA PO konfiguratorze.
   * Strona główna ma ich kilka, a filtr ma dotyczyć tylko tej pierwszej.
   */
  function siatka() {
    var punkt = panel();
    if (!punkt) return null;
    var kandydaci = document.querySelectorAll('.product-grid');
    for (var i = 0; i < kandydaci.length; i++) {
      if (punkt.compareDocumentPosition(kandydaci[i]) & Node.DOCUMENT_POSITION_FOLLOWING) {
        return kandydaci[i];
      }
    }
    return null;
  }

  function karty(g) {
    return g ? g.querySelectorAll(':scope > li') : [];
  }

  function uchwytKarty(karta) {
    var link = karta.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var dopasowanie = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return dopasowanie ? decodeURIComponent(dopasowanie[1]) : '';
  }

  function koloryKarty(karta) {
    var lista = karta.querySelector('[data-kolory]');
    if (!lista) return {};
    var mapa = {};
    var wpisy = (lista.getAttribute('data-kolory') || '').split(ROZDZIELNIK_POZYCJI);
    for (var i = 0; i < wpisy.length; i++) {
      var czesci = wpisy[i].split('|');
      var etykieta = (czesci[0] || '').trim();
      if (etykieta) {
        mapa[etykieta.toLowerCase()] = {
          zdjecie: (czesci[1] || '').trim(),
          adres: (czesci[2] || '').trim(),
        };
      }
    }
    return mapa;
  }

  /*
   * Szybkie dodawanie do koszyka otwiera okno z formularzem produktu, a Dawn
   * pobiera je spod adresu z `data-product-url`. Przy wybranym kolorze
   * podmieniamy ten adres na adres wariantu — okno otwiera się wtedy od razu
   * na tej barwie i klient dobiera już tylko rozmiar.
   */
  function ustawSzybkiZakup(karta, adres) {
    var przycisk = karta.querySelector('[data-product-url]');
    if (!przycisk) return;
    if (!przycisk.dataset.pierwotnyUrl) {
      przycisk.dataset.pierwotnyUrl = przycisk.getAttribute('data-product-url') || '';
    }
    przycisk.setAttribute('data-product-url', adres || przycisk.dataset.pierwotnyUrl);
  }

  function obrazekKarty(karta) {
    return karta.querySelector('.card__media img, .card__inner img');
  }

  /*
   * Warianty karty: `kolor|kod rozmiaru|id` (snippets/karta-warianty.liquid).
   * Same dostępne — filtr rasy ma prowadzić do rozmiaru, który da się kupić.
   */
  function wariantyKarty(karta) {
    var nosnik = karta.querySelector('[data-warianty]');
    if (!nosnik) return [];
    if (nosnik.__lista) return nosnik.__lista;
    var lista = [];
    var wpisy = (nosnik.getAttribute('data-warianty') || '').split(ROZDZIELNIK_POZYCJI);
    for (var i = 0; i < wpisy.length; i++) {
      var c = wpisy[i].split('|');
      if (c.length < 3) continue;
      lista.push({
        kolor: (c[0] || '').trim().toLowerCase(),
        kod: (c[1] || '').trim(),
        id: (c[2] || '').trim(),
        cena: (c[3] || '').trim(),
      });
    }
    nosnik.__lista = lista;
    return lista;
  }

  /*
   * Wariant pod bieżące ustawienia. Rozmiary rasy są uporządkowane od
   * najmniejszego, więc bierzemy pierwszy pasujący — na dwie pasujące miary
   * podpowiadamy mniejszą, bo legowisko ma być przytulne, a nie za duże.
   */
  function dobierzWariant(karta) {
    if (!stan.rozmiary.length) return null;
    var warianty = wariantyKarty(karta);
    if (!warianty.length) return null;
    for (var r = 0; r < stan.rozmiary.length; r++) {
      for (var i = 0; i < warianty.length; i++) {
        if (warianty[i].kod !== stan.rozmiary[r]) continue;
        if (stan.kolor && warianty[i].kolor !== stan.kolor.toLowerCase()) continue;
        return warianty[i];
      }
    }
    return null;
  }

  /*
   * Link karty prowadzi wtedy prosto na dobrany wariant — klient wchodzi
   * na kartę produktu z ustawionym rozmiarem (i kolorem, jeśli wybrany).
   * Próbek kolorów nie ruszamy: one mają zostać przy swoich wariantach.
   */
  function ustawLinki(karta, idWariantu) {
    var linki = karta.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < linki.length; i++) {
      var a = linki[i];
      if (a.closest('.card-swatches')) continue;
      if (!a.dataset.pierwotnyHref) a.dataset.pierwotnyHref = a.getAttribute('href') || '';
      var bazowy = a.dataset.pierwotnyHref.split('?')[0];
      a.setAttribute('href', idWariantu ? bazowy + '?variant=' + idWariantu : a.dataset.pierwotnyHref);
    }
  }

  /*
   * Cena dobranego rozmiaru zamiast widełek „Od …".
   * Podmieniamy tylko treść bloku ceny, oryginał chowamy w `dataset`, żeby
   * dało się go przywrócić po zdjęciu filtra.
   */
  function ustawCene(karta, cena) {
    var blok = karta.querySelector('.price');
    if (!blok) return;
    if (blok.dataset.pierwotnaCena === undefined) blok.dataset.pierwotnaCena = blok.innerHTML;
    if (cena) {
      blok.innerHTML =
        '<div class="price__container"><div class="price__regular">' +
        '<span class="price-item price-item--regular">' + cena + '</span>' +
        '</div></div>';
    } else {
      blok.innerHTML = blok.dataset.pierwotnaCena;
    }
  }

  /*
   * Podmiana kadru. `srcset` trzeba wyzerować — inaczej przeglądarka i tak
   * wybierze zdjęcie ze starej listy i podmiana `src` nic nie da.
   */
  function ustawZdjecie(karta, adres) {
    var img = obrazekKarty(karta);
    if (!img || !adres) return;
    if (!img.dataset.pierwotnySrc) {
      img.dataset.pierwotnySrc = img.getAttribute('src') || '';
      img.dataset.pierwotnySrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('srcset', '');
    img.setAttribute('src', adres);
  }

  function przywrocZdjecie(karta) {
    var img = obrazekKarty(karta);
    if (!img || !img.dataset.pierwotnySrc) return;
    img.setAttribute('src', img.dataset.pierwotnySrc);
    if (img.dataset.pierwotnySrcset) img.setAttribute('srcset', img.dataset.pierwotnySrcset);
  }

  /* ── Karuzele pasków: strzałki, kółko myszy, przeciąganie ──────────── */

  function listaKaruzeli(el) {
    var karuzela = el.closest('.konfigurator__karuzela');
    return karuzela ? karuzela.querySelector('.konfigurator__lista') : null;
  }

  function odswiezStrzalki(lista) {
    var karuzela = lista.closest('.konfigurator__karuzela');
    if (!karuzela) return;
    var przewijalna = lista.scrollWidth > lista.clientWidth + 2;
    var strzalki = karuzela.querySelectorAll('[data-przewin]');
    for (var i = 0; i < strzalki.length; i++) {
      strzalki[i].hidden = !przewijalna;
      if (!przewijalna) continue;
      var wprzod = strzalki[i].getAttribute('data-przewin') === '1';
      var koniec = lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 2;
      strzalki[i].disabled = wprzod ? koniec : lista.scrollLeft <= 2;
    }
  }

  function wepnijKaruzele() {
    var listy = document.querySelectorAll('.konfigurator__lista');
    for (var i = 0; i < listy.length; i++) {
      (function (lista) {
        odswiezStrzalki(lista);
        lista.addEventListener('scroll', function () {
          odswiezStrzalki(lista);
        }, { passive: true });

        /*
         * Przeciąganie kursorem. Klik trzeba przepuścić, więc dopiero ruch
         * powyżej progu robi z gestu przewijanie — i wtedy blokujemy najbliższy
         * `click`, żeby puszczenie myszy nad kółkiem nie włączyło filtra.
         */
        var ciagnie = false;
        var przesunieto = false;
        var startX = 0;
        var startScroll = 0;

        /*
         * Pasek „Rodzaj" składa się z linków, a te mają natywne przeciąganie
         * (drag & drop). Przechwytywało wskaźnik i zamiast przewijać, ciągnęło
         * ducha linku — stąd twarda blokada na całym pasku.
         */
        lista.addEventListener('dragstart', function (e) {
          e.preventDefault();
        });

        lista.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'touch') return; // dotyk ma natywne przewijanie
          e.preventDefault(); // bez tego link zaczyna się przeciągać
          ciagnie = true;
          przesunieto = false;
          startX = e.clientX;
          startScroll = lista.scrollLeft;
        });

        lista.addEventListener('pointermove', function (e) {
          if (!ciagnie) return;
          var delta = e.clientX - startX;
          if (!przesunieto && Math.abs(delta) < 5) return;
          if (!przesunieto) {
            przesunieto = true;
            lista.classList.add('jest-ciagniety');
            lista.setPointerCapture(e.pointerId);
          }
          lista.scrollLeft = startScroll - delta;
          e.preventDefault();
        });

        function koniec() {
          if (!ciagnie) return;
          ciagnie = false;
          lista.classList.remove('jest-ciagniety');
          if (przesunieto) {
            lista.addEventListener('click', function blok(e) {
              e.preventDefault();
              e.stopPropagation();
              lista.removeEventListener('click', blok, true);
            }, true);
          }
        }

        lista.addEventListener('pointerup', koniec);
        lista.addEventListener('pointercancel', koniec);
        lista.addEventListener('pointerleave', koniec);
      })(listy[i]);
    }

    window.addEventListener('resize', function () {
      var wszystkie = document.querySelectorAll('.konfigurator__lista');
      for (var i = 0; i < wszystkie.length; i++) odswiezStrzalki(wszystkie[i]);
    });
  }

  function filtruj() {
    var g = siatka();
    if (!g) return;

    var lista = karty(g);
    var widocznych = 0;

    for (var i = 0; i < lista.length; i++) {
      var karta = lista[i];
      var zZapasu = karta.classList.contains('filtr-zapas');
      var pasuje;

      if (stan.zapas) {
        // Tryb wyprzedaży: pokazujemy WYŁĄCZNIE karty z zapasu tego rodzaju
        pasuje = zZapasu && karta.getAttribute('data-rodzaj') === stan.rodzaj;
      } else if (zZapasu) {
        pasuje = false;
      } else {
        pasuje = true;
        if (stan.rodzaj && stan.uchwyty) {
          pasuje = stan.uchwyty.indexOf(',' + uchwytKarty(karta) + ',') !== -1;
        }
      }

      var wybrany = null;
      if (pasuje && stan.kolor && !stan.zapas) {
        wybrany = koloryKarty(karta)[stan.kolor.toLowerCase()];
        if (!wybrany) pasuje = false;
      }

      // Rasa: karta musi mieć dostępny wariant w rozmiarze pasującym na tę rasę
      var wariant = null;
      if (pasuje && stan.rasa && !stan.zapas) {
        wariant = dobierzWariant(karta);
        if (!wariant) pasuje = false;
      }
      ustawLinki(karta, wariant ? wariant.id : null);
      ustawCene(karta, wariant ? wariant.cena : null);

      if (pasuje) {
        karta.classList.remove(UKRYTA);
        if (wybrany) {
          ustawZdjecie(karta, wybrany.zdjecie);
          ustawSzybkiZakup(karta, wybrany.adres);
        } else {
          przywrocZdjecie(karta);
          ustawSzybkiZakup(karta, null);
        }
        widocznych++;
      } else {
        karta.classList.add(UKRYTA);
      }
    }

    odswiezPodsumowanie(widocznych);
  }

  function odswiezPodsumowanie(widocznych) {
    var p = panel();
    if (!p) return;

    var plakietki = p.querySelector('[data-plakietki]');
    if (plakietki) {
      plakietki.innerHTML = '';
      if (stan.rodzaj) plakietki.appendChild(plakietka(stan.rodzajPodpis || stan.rodzaj, 'rodzaj'));
      if (stan.kolor) plakietki.appendChild(plakietka(stan.kolor, 'kolor'));
      if (stan.rasa) {
        plakietki.appendChild(plakietka(stan.rasa + ' · rozm. ' + stan.rozmiary.join('/'), 'rasa'));
      }
    }

    var wyczysc = p.querySelector('[data-wyczysc]');
    if (wyczysc) wyczysc.hidden = !stan.rodzaj && !stan.kolor && !stan.rasa;

    var pusto = p.querySelector('[data-filtr-pusto]');
    if (pusto) pusto.hidden = widocznych > 0;
  }

  function plakietka(tekst, rodzajFiltra) {
    var el = document.createElement('span');
    el.className = 'konfigurator__plakietka';
    el.appendChild(document.createTextNode(tekst));
    var zdejmij = document.createElement('button');
    zdejmij.type = 'button';
    zdejmij.setAttribute('aria-label', 'Usuń filtr: ' + tekst);
    zdejmij.setAttribute('data-zdejmij', rodzajFiltra);
    zdejmij.textContent = '×';
    el.appendChild(zdejmij);
    return el;
  }

  /*
   * Po zmianie filtra siatka się kurczy i treść pod nią jedzie w górę — klient
   * zostawał wtedy gdzieś w połowie strony, przy zupełnie innej sekcji
   * (zgłoszone 2026-09-03). Wracamy więc na początek wyników, tuż pod pasek.
   */
  function przewinDoWynikow() {
    var g = siatka();
    var p = panel();
    if (!g || !p) return;
    var pasek = p.closest('.konfigurator-sekcja') || p;
    var naglowek = document.querySelector('.header-wrapper, .section-header');
    var zapas = (naglowek ? naglowek.getBoundingClientRect().height : 0) +
      (pasek.classList.contains('jest-schowany') ? 44 : pasek.getBoundingClientRect().height) + 16;
    var cel = g.getBoundingClientRect().top + window.scrollY - zapas;
    if (window.scrollY <= cel && window.scrollY > cel - 40) return; // już jesteśmy na miejscu
    window.scrollTo({ top: Math.max(0, Math.round(cel)), behavior: 'smooth' });
  }

  /*
   * Zwijanie z animacją wysokości. `max-height` ustawiamy z realnej wysokości
   * treści, a po zakończeniu przejścia zdejmujemy je przy rozwijaniu — inaczej
   * pasek nie urósłby po zmianie liczby filtrów.
   */
  function przelaczZwijanie(sekcja, przycisk) {
    var tresc = sekcja.querySelector('[data-zwijane]');
    if (!tresc) return;
    var schowany = !sekcja.classList.contains('jest-schowany');

    tresc.style.maxHeight = tresc.scrollHeight + 'px';
    // wymuszenie przeliczenia, żeby przeglądarka zobaczyła punkt startowy
    void tresc.offsetHeight;

    sekcja.classList.toggle('jest-schowany', schowany);
    przycisk.setAttribute('aria-expanded', schowany ? 'false' : 'true');
    var napis = przycisk.querySelector('[data-zwin-napis]');
    if (napis) napis.textContent = schowany ? 'Pokaż filtry' : 'Ukryj filtry';

    if (schowany) {
      window.requestAnimationFrame(function () {
        tresc.style.maxHeight = '0px';
      });
    } else {
      tresc.addEventListener('transitionend', function koniec(e) {
        if (e.propertyName !== 'max-height') return;
        tresc.style.maxHeight = '';
        tresc.removeEventListener('transitionend', koniec);
      });
      window.requestAnimationFrame(function () {
        tresc.style.maxHeight = tresc.scrollHeight + 'px';
      });
    }
  }

  function zaznacz(selektor, wartosc, atrybut) {
    var wszystkie = document.querySelectorAll(selektor);
    for (var i = 0; i < wszystkie.length; i++) {
      var aktywny = (wszystkie[i].getAttribute(atrybut) || '') === wartosc;
      wszystkie[i].classList.toggle('is-active', aktywny);
      if (wszystkie[i].hasAttribute('aria-pressed')) {
        wszystkie[i].setAttribute('aria-pressed', aktywny ? 'true' : 'false');
      }
    }
  }

  function ustawKolor(wartosc) {
    stan.kolor = wartosc;
    zaznacz('[data-filtr-kolor]', wartosc, 'data-filtr-kolor');
  }

  function ustawRase(przycisk) {
    var wartosc = przycisk ? przycisk.getAttribute('data-filtr-rasa') || '' : '';
    stan.rasa = wartosc;
    stan.rozmiary = wartosc && przycisk
      ? (przycisk.getAttribute('data-rozmiary') || '').split(',').filter(Boolean)
      : [];
    zaznacz('[data-filtr-rasa]', wartosc, 'data-filtr-rasa');
  }

  /* Czy w bieżącej siatce jest choć jedna karta pasująca do tego rodzaju */
  function maCoPokazac(przycisk) {
    var g = siatka();
    if (!g) return false;
    var wartosc = przycisk.getAttribute('data-filtr-rodzaj') || '';
    var zapas = !!przycisk.getAttribute('data-bez-koloru');
    var uchwyty = ',' + (przycisk.getAttribute('data-produkty') || '') + ',';
    var lista = karty(g);
    for (var i = 0; i < lista.length; i++) {
      var karta = lista[i];
      var zZapasu = karta.classList.contains('filtr-zapas');
      if (zapas) {
        if (zZapasu && karta.getAttribute('data-rodzaj') === wartosc) return true;
      } else if (!zZapasu && uchwyty.indexOf(',' + uchwytKarty(karta) + ',') !== -1) {
        return true;
      }
    }
    return false;
  }

  function ustawRodzaj(przycisk) {
    var wartosc = przycisk ? przycisk.getAttribute('data-filtr-rodzaj') || '' : '';
    stan.rodzaj = wartosc;
    stan.uchwyty = wartosc && przycisk ? ',' + (przycisk.getAttribute('data-produkty') || '') + ',' : null;
    stan.zapas = !!(wartosc && przycisk && przycisk.getAttribute('data-bez-koloru'));

    var podpis = przycisk ? przycisk.querySelector('.konfigurator__podpis') : null;
    stan.rodzajPodpis = podpis ? podpis.textContent.trim() : wartosc;

    zaznacz('[data-filtr-rodzaj]', wartosc, 'data-filtr-rodzaj');

    /*
     * Przy wyprzedaży kolor ani rasa nie mają z czym pracować: karty biorą się
     * z osobnego zapasu, a nie z siatki, więc gasimy oba rzędy.
     */
    var rzadKolorow = document.querySelector('[data-rzad-kolorow]');
    if (rzadKolorow) rzadKolorow.classList.toggle('is-wylaczony', stan.zapas);
    var uwagaKoloru = document.querySelector('[data-kolor-wylaczony]');
    if (uwagaKoloru) uwagaKoloru.hidden = !stan.zapas;

    var rzadRas = document.querySelector('[data-rzad-ras]');
    if (rzadRas) rzadRas.classList.toggle('is-wylaczony', stan.zapas);
    var uwagaRasy = document.querySelector('[data-rasa-wylaczona]');
    if (uwagaRasy) uwagaRasy.hidden = !stan.zapas;

    if (stan.zapas) {
      ustawKolor('');
      ustawRase(null);
    }
  }

  document.addEventListener('click', function (e) {
    var zwin = e.target.closest('[data-zwin]');
    if (zwin) {
      e.preventDefault();
      var sekcja = zwin.closest('.konfigurator-sekcja') || panel();
      if (!sekcja) return;
      przelaczZwijanie(sekcja, zwin);
      return;
    }

    /*
     * Zakładki telefonu: otwarty jest najwyżej jeden rząd. Ponowny klik
     * w aktywną zakładkę zamyka pasek, żeby dało się wrócić do samych produktów.
     */
    var zakladka = e.target.closest('[data-zakladka]');
    if (zakladka) {
      e.preventDefault();
      var nazwa = zakladka.getAttribute('data-zakladka');
      var otwarta = zakladka.getAttribute('aria-expanded') === 'true';
      var zakladki = document.querySelectorAll('[data-zakladka]');
      for (var z = 0; z < zakladki.length; z++) {
        zakladki[z].setAttribute('aria-expanded', 'false');
      }
      var rzedy = document.querySelectorAll('[data-rzad]');
      for (var r = 0; r < rzedy.length; r++) {
        var pasuje = !otwarta && rzedy[r].getAttribute('data-rzad') === nazwa;
        rzedy[r].classList.toggle('jest-otwarty', pasuje);
        if (pasuje) {
          zakladka.setAttribute('aria-expanded', 'true');
          var lista = rzedy[r].querySelector('.konfigurator__lista');
          if (lista) odswiezStrzalki(lista);
        }
      }
      return;
    }

    var strzalka = e.target.closest('[data-przewin]');
    if (strzalka) {
      e.preventDefault();
      var lista = listaKaruzeli(strzalka);
      if (!lista) return;
      var krok = Math.max(160, Math.round(lista.clientWidth * 0.8));
      lista.scrollBy({ left: krok * Number(strzalka.getAttribute('data-przewin')), behavior: 'smooth' });
      return;
    }

    var zdejmij = e.target.closest('[data-zdejmij]');
    if (zdejmij) {
      e.preventDefault();
      var co = zdejmij.getAttribute('data-zdejmij');
      if (co === 'kolor') ustawKolor('');
      else if (co === 'rasa') ustawRase(null);
      else ustawRodzaj(null);
      filtruj();
      return;
    }

    if (e.target.closest('[data-wyczysc]')) {
      e.preventDefault();
      ustawRodzaj(null);
      ustawKolor('');
      ustawRase(null);
      filtruj();
      return;
    }

    var rasa = e.target.closest('[data-filtr-rasa]');
    if (rasa) {
      e.preventDefault();
      if (stan.zapas) return;
      if (rasa.classList.contains('is-active') && (rasa.getAttribute('data-filtr-rasa') || '')) {
        ustawRase(null);
      } else {
        ustawRase(rasa);
      }
      filtruj();
      przewinDoWynikow();
      return;
    }

    var kolor = e.target.closest('[data-filtr-kolor]');
    if (kolor) {
      e.preventDefault();
      if (stan.zapas) return;
      var wybrany = kolor.getAttribute('data-filtr-kolor') || '';
      // Ponowny klik w aktywny kolor zdejmuje filtr
      if (kolor.classList.contains('is-active') && wybrany) wybrany = '';
      ustawKolor(wybrany);
      filtruj();
      przewinDoWynikow();
      return;
    }

    var rodzaj = e.target.closest('[data-filtr-rodzaj]');
    if (rodzaj) {
      // Filtrujemy zamiast przechodzić do kolekcji — ale tylko gdy jest co filtrować
      if (!siatka()) return;
      /*
       * Gdy w TEJ siatce nie ma ani jednej karty tego rodzaju, filtr pokazałby
       * pustkę (zgłoszone 2026-09-16: „Wyprzedaż” na /collections/all — zapas
       * kart wyprzedaży renderuje tylko strona główna; to samo dotyczy każdego
       * rodzaju na stronie kolekcji, której produkty się z nim nie pokrywają).
       * Wtedy puszczamy link i klient ląduje w kolekcji tego rodzaju.
       */
      var wartoscRodzaju = rodzaj.getAttribute('data-filtr-rodzaj') || '';
      if (wartoscRodzaju && !rodzaj.classList.contains('is-active') && !maCoPokazac(rodzaj)) return;
      e.preventDefault();
      if (rodzaj.classList.contains('is-active') && (rodzaj.getAttribute('data-filtr-rodzaj') || '')) {
        ustawRodzaj(null);
      } else {
        ustawRodzaj(rodzaj);
      }
      filtruj();
      przewinDoWynikow();
    }
  });

  /* ── Przypięcie paska pod nagłówkiem ──────────────────────────────── */

  function wysokoscNaglowka() {
    var naglowek = document.querySelector('.header-wrapper, .section-header');
    return naglowek ? Math.round(naglowek.getBoundingClientRect().height) : 0;
  }

  /*
   * Pasek zwija się, gdy siatka produktów zjedzie w górę poza ekran (czyli
   * wjeżdżamy w kolejne sekcje strony) i wraca, gdy produkty znów są widoczne.
   */
  function wepnijPrzypiecie() {
    var p = panel();
    var g = siatka();
    if (!p || !g) return;
    var sekcja = g.closest('.collection') || g;
    var pasek = p.closest('.konfigurator-sekcja') || p;

    function przelicz() {
      var gora = wysokoscNaglowka();
      pasek.style.setProperty('--konfigurator-gora', gora + 'px');
      var r = sekcja.getBoundingClientRect();
      var wysokosc = pasek.getBoundingClientRect().height;
      var prog = gora + wysokosc + 24;
      /*
       * Histereza: chowamy na progu, ale pokazujemy dopiero 90 px niżej.
       * Bez tego przy powolnym przewijaniu dokładnie na granicy pasek
       * przełączał się kilka razy pod rząd i animacja wyglądała na szarpaną.
       */
      var zwiniety = pasek.classList.contains('jest-zwiniety');
      var zwin = zwiniety ? r.bottom < prog + 90 : r.bottom < prog;
      if (zwin !== zwiniety) pasek.classList.toggle('jest-zwiniety', zwin);

      /*
       * Klasa `ma-tlo` = pasek dojechał do swojej pozycji przypięcia i od tej
       * chwili jedzie NAD kartami produktów. Dopiero wtedy dostaje tło i cień
       * (CSS: `.konfigurator-sekcja.ma-tlo`) — na starcie ma być przezroczysty,
       * żeby zlewał się ze stroną. Dotyczy wszystkich stron z paskiem,
       * nie tylko głównej.
       */
      pasek.classList.toggle('ma-tlo', pasek.getBoundingClientRect().top <= gora + 1);
    }

    var czeka = false;
    function naZdarzenie() {
      if (czeka) return;
      czeka = true;
      window.requestAnimationFrame(function () {
        czeka = false;
        przelicz();
      });
    }

    window.addEventListener('scroll', naZdarzenie, { passive: true });
    window.addEventListener('resize', naZdarzenie);
    przelicz();
  }

  /*
   * Piktogramy zakładek: zamiast ogólnych ikon pokazujemy trzy pierwsze
   * realne kółka z danego paska (kolory, rodzaje, rasy) w miniaturze —
   * po samym przycisku widać, co jest w środku.
   */
  function zbudujPiktogramy() {
    var zakladki = document.querySelectorAll('[data-zakladka]');
    for (var i = 0; i < zakladki.length; i++) {
      var nazwa = zakladki[i].getAttribute('data-zakladka');
      var rzad = document.querySelector('[data-rzad="' + nazwa + '"]');
      if (!rzad) continue;
      // pomijamy „Wszystkie" — puste kółko nic nie mówi
      var kolka = rzad.querySelectorAll('.konfigurator__pozycja:not(:first-child) .konfigurator__kolko');
      if (!kolka.length) continue;

      var grupa = document.createElement('span');
      grupa.className = 'konfigurator__piktogramy';
      for (var k = 0; k < Math.min(3, kolka.length); k++) {
        var mini = kolka[k].cloneNode(true);
        mini.className = 'konfigurator__mini';
        mini.removeAttribute('aria-hidden');
        grupa.appendChild(mini);
      }
      var stary = zakladki[i].querySelector('.konfigurator__piktogram');
      if (stary) stary.replaceWith(grupa);
    }
  }

  /*
   * Zapowiedź przy zwiniętym pasku: kilka pierwszych kolorów w miniaturze,
   * żeby po samym przycisku było widać, co się chowa.
   */
  function zbudujProbkiPrzycisku() {
    var miejsce = document.querySelector('[data-zwin-probki]');
    if (!miejsce || miejsce.children.length) return;
    var kolka = document.querySelectorAll('[data-rzad="kolor"] .konfigurator__pozycja:not(:first-child) .konfigurator__kolko');
    for (var i = 0; i < Math.min(5, kolka.length); i++) {
      var mini = kolka[i].cloneNode(true);
      mini.className = 'konfigurator__mini';
      miejsce.appendChild(mini);
    }
  }

  function start() {
    /*
     * Karty z zapasu przychodzą z atrybutem `hidden`. Przenosimy je na klasę,
     * żeby cała widoczność szła jednym mechanizmem — inaczej `hidden` zostałby
     * na karcie i wygrał z klasą przy odsłanianiu.
     */
    var zapas = document.querySelectorAll('.filtr-zapas[hidden]');
    for (var i = 0; i < zapas.length; i++) {
      zapas[i].removeAttribute('hidden');
      zapas[i].classList.add(UKRYTA);
    }
    if (panel()) {
      zbudujPiktogramy();
      zbudujProbkiPrzycisku();
      wepnijKaruzele();
      wepnijPrzypiecie();
      filtruj();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
